import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpdateRightLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Update right",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.7361 11.2624C4.93124 11.2238 5.1337 11.2644 5.29893 11.3752L8.08992 13.246C8.43398 13.4766 8.52594 13.9425 8.29531 14.2866C8.06468 14.6306 7.5988 14.7226 7.25473 14.492L5.08674 13.0388L3.62307 15.2224C3.39245 15.5665 2.92656 15.6584 2.58249 15.4278C2.23842 15.1972 2.14646 14.7313 2.37708 14.3872L4.25834 11.5806C4.36909 11.4154 4.54095 11.3009 4.7361 11.2624Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.418 8.56837C21.7621 8.79899 21.8541 9.26488 21.6234 9.60895L19.7422 12.4156C19.6314 12.5808 19.4596 12.6953 19.2644 12.7338C19.0693 12.7723 18.8668 12.7318 18.7016 12.621L15.9106 10.7502C15.5665 10.5196 15.4746 10.0537 15.7052 9.70961C15.9358 9.36554 16.4017 9.27358 16.7458 9.50421L18.9138 10.9574L20.3775 8.77378C20.6081 8.42971 21.074 8.33774 21.418 8.56837Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.8965 11.4025C5.31062 11.3939 5.65333 11.7226 5.66195 12.1367C5.73356 15.5756 8.54475 18.3424 12.001 18.3424C14.1653 18.3424 16.077 17.2585 17.2218 15.601C17.4572 15.2601 17.9243 15.1747 18.2651 15.41C18.606 15.6454 18.6914 16.1126 18.456 16.4534C17.0431 18.4992 14.6787 19.8424 12.001 19.8424C7.72677 19.8424 4.25084 16.4212 4.16228 12.168C4.15365 11.7538 4.48237 11.4111 4.8965 11.4025Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.54505 7.54525C6.95797 5.49945 9.32239 4.15625 12.0001 4.15625C16.2743 4.15625 19.7503 7.5774 19.8388 11.8307C19.8474 12.2448 19.5187 12.5875 19.1046 12.5961C18.6905 12.6047 18.3478 12.276 18.3391 11.8619C18.2675 8.42298 15.4563 5.65625 12.0001 5.65625C9.83579 5.65625 7.92406 6.74014 6.7793 8.39767C6.54391 8.7385 6.07679 8.82397 5.73596 8.58858C5.39514 8.35319 5.30966 7.88607 5.54505 7.54525Z",
			fill: "currentColor"
		})
	]
});
export default SvgUpdateRightLine;
